import { Section } from './incidentRosterChart.types';

export const Sections: Section[] = [
  {
    name: 'Operations Section',
    borderColor: '#ea0e0e',
    sectionSeatName: 'Operations Section Chief',
  },
  {
    name: 'Planning Section',
    borderColor: '#4273d5',
    sectionSeatName: 'Planning Section Chief',
  },
  {
    name: 'Logistics Section',
    borderColor: '#fb9905',
    sectionSeatName: 'Logistics Section Chief',
  },
  {
    name: 'Finance/Admin Section',
    borderColor: '#38ca22',
    sectionSeatName: 'Finance Section Chief',
  },
  {
    name: 'Intel/Investigations Section',
    borderColor: '#d6802a63',
    sectionSeatName: 'Intel/Investigations Section Chief',
  },
  {
    name: 'Command Staff',
    borderColor: 'none',
    sectionSeatName: 'Incident Commander',
  },
];

export const planningSectionOrder = [
  'Resource Unit Leader',
  'Situation Unit Leader',
  'Documentation Unit Leader',
  'Demobilization Unit Leader',
  'Environmental Unit Leader',
  'Technical Specialist',
];

export const commandStaffOrder = [
  'Public Information Officer',
  'Liaison Officer',
  'Safety Officer',
  'Legal Officer',
];
